import React from 'react';
import { motion } from 'framer-motion';
import { FaTrophy, FaFire, FaStar } from 'react-icons/fa';

const Progress = () => {
    const subjects = [
        { name: 'Mathematics', progress: 75, grade: 'A', lessons: 24, color: '#2B7A8C' },
        { name: 'Physics', progress: 60, grade: 'B+', lessons: 18, color: '#FFD700' },
        { name: 'Chemistry', progress: 85, grade: 'A*', lessons: 28, color: '#2B7A8C' },
        { name: 'Biology', progress: 50, grade: 'B', lessons: 15, color: '#FFD700' }
    ];

    return (
        <div>
            <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--color-secondary)', marginBottom: '0.5rem' }}>My Progress</h1>
            <p style={{ color: '#666', marginBottom: '2rem' }}>Track your learning journey</p>

            {/* Stats Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--color-teal-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaTrophy size={24} color="var(--color-primary)" />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.9rem', color: '#666' }}>Total Lessons</div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>85</div>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#FFF9E6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaFire size={24} color="var(--color-accent)" />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.9rem', color: '#666' }}>Study Streak</div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>12 Days</div>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--color-teal-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaStar size={24} color="var(--color-primary)" />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.9rem', color: '#666' }}>Avg. Grade</div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>A-</div>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* Subject Progress */}
            <h3 style={{ fontWeight: '600', marginBottom: '1rem', fontSize: '1.2rem' }}>Subject Progress</h3>
            <div style={{ display: 'grid', gap: '1.5rem' }}>
                {subjects.map((subject, index) => (
                    <motion.div
                        key={subject.name}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.1 }}
                        style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                            <div>
                                <h4 style={{ fontWeight: '600', marginBottom: '0.25rem' }}>{subject.name}</h4>
                                <div style={{ fontSize: '0.9rem', color: '#666' }}>{subject.lessons} lessons completed</div>
                            </div>
                            <div style={{
                                background: subject.grade.includes('A') ? 'var(--color-teal-light)' : '#FFF9E6',
                                color: subject.grade.includes('A') ? 'var(--color-primary)' : 'var(--color-accent)',
                                padding: '0.5rem 1rem',
                                borderRadius: '8px',
                                fontWeight: '600'
                            }}>
                                Grade: {subject.grade}
                            </div>
                        </div>
                        <div style={{ background: '#f0f0f0', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
                            <div style={{
                                width: `${subject.progress}%`,
                                height: '100%',
                                background: subject.color,
                                transition: 'width 1s ease-out'
                            }}></div>
                        </div>
                        <div style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#666', textAlign: 'right' }}>{subject.progress}% Complete</div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Progress;
